import React, { useMemo, useState } from "react";
import { compose } from "redux";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { UsersOverviewConnector } from "../../../../services/users/connectors/Users.Overview.Connector";

const InvestorLevel = ({ currentUser, setMinEffectiveInvestorLevel }) => {
  const mainInfoStyle = { padding: "8px 4px 4px 16px" };
  const investorLevels = [
    { name: "Regular", level: 1 },
    { name: "Bronze", level: 2 },
    { name: "Silver", level: 3 },
    { name: "Gold", level: 4 },
    { name: "Platinum", level: 5 },
    { name: "Opal", level: 6 },
    { name: "Ruby", level: 7 },
    { name: "Diamond", level: 8 },
    { name: "Special - fee: 10% - 2nd: 0%", level: 100 },
    { name: "Special - fee: 10% - 2nd: 0.5%", level: 105 },
    { name: "Special - fee: 6% - 2nd: 0%", level: 106 },
    { name: "Special - fee: 5% - 2nd: 1%", level: 107 },
    { name: "Special - fee: 4% - 2nd: 1%", level: 108 },
    { name: "Special - fee: 4% - 2nd: 2%", level: 109 },
    { name: "VIP", level: 1337 },
  ];
  const [effectiveLabel, computedLabel, minEffectiveLabel] = useMemo(() => {
    return [
      getInvestorLevelName(currentUser.InvestorLevel.Effective),
      getInvestorLevelName(currentUser.InvestorLevel.Computed),
      getInvestorLevelName(currentUser.InvestorLevel.MinEffective),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const [investorLevel, changeInvestorLevel] = useState(
    currentUser.InvestorLevel.MinEffective,
  );

  return (
    <React.Fragment>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={effectiveLabel}
          secondary="Effective Investor Level"
        />
      </ListItem>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={computedLabel}
          secondary="Computed Investor Level"
        />
      </ListItem>
      <ListItem disabled={true} style={mainInfoStyle}>
        <ListItemText
          primary={minEffectiveLabel}
          secondary="Minimum Effective Investor Level"
        />
      </ListItem>
      <br />
      <TextField
        size="small"
        variant="outlined"
        select
        label="Minimum Investor Level"
        menuItemStyle={{ color: "#000000" }}
        onChange={(e) => changeInvestorLevel(e.target.value)}
        value={investorLevel}
      >
        {investorLevels.map((item) => {
          return (
            <MenuItem key={item.level} value={item.level}>
              {item.name}
            </MenuItem>
          );
        })}
      </TextField>
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          setMinEffectiveInvestorLevel(investorLevel, currentUser.Id)
        }
      >
        Set Minimum Effective Level
      </Button>
    </React.Fragment>
  );

  function getInvestorLevelName(investorLevel) {
    return investorLevels.find((x) => x.level === investorLevel).name;
  }
};

export default compose(UsersOverviewConnector)(InvestorLevel);
